import { XIcon as PhosphorXIcon } from "@phosphor-icons/react/dist/ssr/X";

import { createAppIcon } from "@/components/createAppIcon";

export const CloseIcon = /* @__PURE__ */ createAppIcon(PhosphorXIcon);
